import { HistoryComponent } from './history/history.component';
import { RequestDetailsComponent } from './request-details/request-details.component';
import { InviteApprovalComponent } from './invite-approval/invite-approval.component';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FormsModule } from '@angular/forms';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';



const routes: Routes = [
  { path: '', component: InviteApprovalComponent,},
  {path:'details',component:RequestDetailsComponent},
  {path:'history',component:HistoryComponent}
]

@NgModule({
  declarations: [InviteApprovalComponent,RequestDetailsComponent,HistoryComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule
  ],
  exports: [RouterModule],
})
export class ApprovalModule {}
